import React, { useEffect, useState } from "react";
import Header from "./Header";
// import Footer from "./Footer";
import Grid from "@mui/material/Grid2";

const DashboardLayout = ({ children, currentLang }) => {
  const [appLinks, setAppLinks] = useState([]);

  useEffect(() => {
    console.log("currentLang inside useEffect", currentLang);
  }, [currentLang]);

  const handleSetAppLinks = (links) => {
    setAppLinks(links); // Save the links in state
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12 }}>
          <Header currentLang={currentLang} appLinks={appLinks} />
        </Grid>
      </Grid>
      {/* Clone and pass handleSetAppLinks to children */}
      {React.Children.map(children, (child) =>
        React.cloneElement(child, { onSetAppLinks: handleSetAppLinks })
      )}
    </>
  );
};

export default DashboardLayout;
